export const WAEC_GEOGRAPHY = [
  {
    q: "The longest river in Africa is:",
    o: ["Congo", "Niger", "Nile", "Zambezi"],
    a: 2,
    e: "The Nile is approximately 6,650 km long, making it the longest river in Africa and one of the longest in the world.",
    h: "Flows through Egypt into the Mediterranean.",
    yr: "2023",
  },
  {
    q: "The process by which water vapour turns into liquid is called:",
    o: ["Evaporation", "Condensation", "Precipitation", "Transpiration"],
    a: 1,
    e: "Condensation occurs when water vapour cools and changes into liquid water, forming clouds and dew.",
    h: "Water cycle — the reverse of evaporation.",
    yr: "2022",
  },
  {
    q: "Lines of longitude are also called:",
    o: ["Parallels", "Meridians", "Tropics", "Isobars"],
    a: 1,
    e: "Lines of longitude (meridians) run from the North Pole to the South Pole. The Prime Meridian (0°) passes through Greenwich.",
    h: "They run vertically on a map.",
    yr: "2023",
  },
  {
    q: "The savanna vegetation is characterised by:",
    o: ["Dense forest canopy", "Grasses with scattered trees", "Absence of vegetation", "Only cactus plants"],
    a: 1,
    e: "Savanna is a tropical grassland biome with scattered trees and a distinct dry season.",
    h: "Think of the African plains.",
    yr: "2021",
  },
  {
    q: "Earthquakes are measured using the:",
    o: ["Barometer", "Thermometer", "Richter scale", "Hygrometer"],
    a: 2,
    e: "The Richter scale measures the magnitude (energy released) of earthquakes.",
    h: "Named after Charles Richter.",
    yr: "2022",
  },
];

export const WAEC_GEOGRAPHY_LEARN = [
  {
    topic: "Map Reading & Scale",
    content: "Scale shows the relationship between map distance and actual distance. Types: linear/graphic, representative fraction (RF), and statement scale. Contour lines connect points of equal elevation; closely spaced = steep slope. Grid references locate points on a map using northings and eastings.",
  },
  {
    topic: "Weather & Climate",
    content: "Weather = short-term atmospheric conditions. Climate = long-term average. Factors affecting climate: latitude, altitude, distance from sea, ocean currents, prevailing winds. Nigeria's climate zones: Guinea Coast (equatorial), Sudan Savanna, Sahel. Instruments: thermometer, barometer, rain gauge, anemometer.",
  },
  {
    topic: "Population Geography",
    content: "Population density = population / area. Factors affecting settlement: water supply, fertile land, flat terrain, climate, resources. Natural increase = birth rate – death rate. Migration: push factors (poverty, conflict) and pull factors (jobs, safety). Population pyramid shows age/sex distribution.",
  },
  {
    topic: "Economic Geography",
    content: "Primary activities: farming, fishing, mining, forestry. Secondary: manufacturing, construction. Tertiary: services, trade, transport. Nigeria's economy: oil dominates exports but agriculture employs most people. Green Revolution aimed to boost food production in developing nations.",
  },
  {
    topic: "Rocks & Landforms",
    content: "Igneous rocks: formed from cooled magma (granite, basalt). Sedimentary: deposited layers, often contain fossils (limestone, sandstone). Metamorphic: changed by heat/pressure (marble, slate). Weathering: physical (freeze-thaw), chemical (acid rain), biological (roots). Erosion transports weathered material.",
  },
];
